import {
  ExportFieldKey,
  type FileFormatSettings,
  type TranscriptExportSettings,
} from '@/shared/types/export';

/**
 * Create a `FileFormatSettings` object from a `TranscriptExportSettings` object.
 */
export function createTranscriptExportSettings({
  export_format: selectedFormatKey,
  ...rest
}: TranscriptExportSettings): FileFormatSettings {
  // It is possible that the input is a superset of TranscriptExportSettings.
  // We only want to include the fields that are defined in TranscriptExportSettings.
  const optionValues = ExportFieldKey.reduce(
    (acc, key) => {
      acc[key] = rest[key];
      return acc;
    },
    {} as FileFormatSettings['optionValues'],
  );

  return {
    selectedFormatKey,
    optionValues,
  };
}
